import {Component, computed, effect, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {Card} from 'primeng/card';
import {Textarea} from 'primeng/textarea';
import {AutoComplete, AutoCompleteCompleteEvent} from 'primeng/autocomplete';
import {Select} from 'primeng/select';
import {BaseOption, ProjectDetails} from '../../../../api';
import {CreateTemplateBaseComponent} from '../create-template-base-component.directive';

/**
 * Template version of create-ta-details. No travel dates (the itinerary's days set the duration)
 * and no approver: both are chosen when a TA is created from the template.
 */
@Component({
  selector: 'create-template-details',
  imports: [
    FormsModule,
    Card,
    Textarea,
    AutoComplete,
    Select,
  ],
  templateUrl: './create-template-details.html',
})
export class CreateTemplateDetails extends CreateTemplateBaseComponent implements OnInit {
  availableProjects = computed<ProjectDetails[]>(() => this.store.availableProjects());
  filteredProjects: ProjectDetails[] = [];
  availablePurposes = computed<BaseOption[]>(() => this.store.session().details?.travelReasonOptions ?? []);
  filteredPurposes: BaseOption[] = [];

  constructor() {
    super();
    effect(() => {
      this.filteredProjects = this.availableProjects();
    });
  }

  ngOnInit(): void {
    this.taSearchDatasource.loadProjectOptions();
  }

  updateProject(event: {value: ProjectDetails}): void {
    const project = event.value;
    if (project?.id) {
      this.templateDatasource.saveField('projectId', project.id, {project});
    }
  }

  updatePurpose(event: {value: BaseOption}): void {
    const purpose = event.value?.value;
    this.templateDatasource.saveField('purpose', purpose, {purpose});
  }

  updatePurposeNotes(event: Event): void {
    const purposeNotes = (event.target as HTMLTextAreaElement).value;
    this.templateDatasource.saveField('purposeNotes', purposeNotes, {purposeNotes});
  }

  filterProjects(event: AutoCompleteCompleteEvent) {
    this.filteredProjects = this.availableProjects().filter(project => project.code?.toLowerCase().includes(event.query.toLowerCase()));
  }

  filterPurposes(event: AutoCompleteCompleteEvent) {
    this.filteredPurposes = this.availablePurposes().filter(option => (option?.label + ' ' + option?.value).toLowerCase().includes(event.query.toLowerCase()));
  }
}
